<template>
  <div class="flex flex-col w-full h-full py-2" style="position: relative">
    <!-- <v-switch class="!grow-0 ml-auto" hide-details v-model="onlyOnGoing" :label="$t('Fleet.OnlyOngoing')"></v-switch>                         -->
    <div class="grid grid-cols-[auto_auto_auto] gap-5 items-center" v-if="associations">
      <FleetGliderAssociationRow
        :disabled="!$store.myGetters.isFleetOnGoing(modified)"
        v-for="(asso, idx) in associations"
        :class="{ 'bg-[#eeeeee]': idx % 2 == 1 }"
        :association="asso"
        :only-on-going="onlyOnGoing"
        :key="asso.key"
      />
    </div>
  </div>
</template>

<script setup lang="ts">
import { ref, computed, watch, nextTick, onMounted } from 'vue'
import store from '@/store'
import { AloDbFleet, AloDbFleetFormation, isAloDbFleetFormation } from '@/models/alodb/AloDbFleet'
import FleetGliderAssociationRow from '@/components/fleet/FleetGliderAssociationRow.vue'

const modified = computed(() => store.myGetters.modifiedAdmAdminFleet as AloDbFleet)

const onlyOnGoing = ref(false)

const config = computed(() => modified.value.config)

const associations = ref<{ key: string; gliKey: string | null; misId: number | null; offsets?: [number, number] }[]>([])

function genereAssociation() {
  associations.value = Object.keys(config.value!.glider_association).map(key => {
    const asso = config.value!.glider_association[key]
    const gliderKey = asso.at(0) as string | null
    const misId = store.myGetters.missions.find(m => m.gliKey?.trim() == gliderKey?.trim() && m.misIdx == asso.at(1))
      ?.misId as number | null
    return {
      key,
      gliKey: gliderKey?.trim() ?? null,
      misId: misId ?? null,
      offsets: asso?.at(2) as [number, number] | undefined,
    }
  })
  modified.value.param.associationIds = associations.value.map(asso => asso.misId!).filter(id => id != null) as number[]
}

genereAssociation()

watch(() => modified.value.FLE_ID, genereAssociation)

watch(
  associations,
  () => {
    modified.value.param.associationIds = associations.value
      .map(asso => asso.misId!)
      .filter(id => id != null) as number[]
    config.value!.glider_association = Object.fromEntries(
      associations.value.map(asso => {
        if (isAloDbFleetFormation(modified.value))
          return [
            asso.key,
            [asso.gliKey?.trim(), asso.misId ? store.myGetters.missionsById[asso.misId].misIdx : null, asso.offsets],
          ]
        else
          return [asso.key, [asso.gliKey?.trim(), asso.misId ? store.myGetters.missionsById[asso.misId].misIdx : null]]
      }),
    )
  },
  { deep: true },
)

defineExpose({
  genereAssociation,
})
</script>
